import { render, staticRenderFns } from "./PremiumHero.vue?vue&type=template&id=5a14672f&scoped=true&"
import script from "./PremiumHero.vue?vue&type=script&lang=js&"
export * from "./PremiumHero.vue?vue&type=script&lang=js&"
import style0 from "./PremiumHero.vue?vue&type=style&index=0&id=5a14672f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a14672f",
  null
  
)

export default component.exports